import { AfterViewInit, Component, ElementRef, forwardRef, inject, Input, OnDestroy, ViewChild } from '@angular/core';
import { GlobalState } from '@base/models/others/global-state';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import * as QRCode from 'qrcode';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ExploreInit } from '@base/models/responses/explore-init.res';
import { ModalService } from '@base/services/private/modal.service';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-qr-code',
  imports: [forwardRef(() => TranslatePipe), ModalHeaderComponent, ModalBodyComponent],
  templateUrl: './modal-qr-code.component.html',
  styleUrl: './modal-qr-code.component.scss',
})
export class ModalQrCodeComponent implements AfterViewInit, OnDestroy {
  @ViewChild('qrCanvas') qrCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() exploreInit: ExploreInit | null = null;
  @Input() modalId = '';

  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);

  globalState: GlobalState | null = null;

  ngAfterViewInit(): void {
    this.initQrCode();
  }

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Initializes the QR code on the canvas element.
   */
  initQrCode(): void {
    const canvas = this.qrCanvas.nativeElement;
    const textToEncode = this.exploreInit?.external_sso_value;

    QRCode.toCanvas(canvas, typeof textToEncode === 'string' ? textToEncode : '', { width: 300 }, (error) => {
      if (error) console.error('QR Code render error:', error);
    });
  }

  /**
   * Closes the current modal via `activeModal.close()`.
   * @returns void
   */
  close(): void {
    this.modalSrv.close(this.modalId);
  }
}
